<template>
  <v-dialog v-model="dialog" width="700">
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>

    <v-card flat tile color="white">
      <v-card-title class="dialog-header-title">
        Copy monthly rates to the next month
      </v-card-title>

      <v-card-text class="py-1">
        <v-row dense>
          <v-col cols="2">
            <span>Source Month:</span>
            <v-select
              class="form-control"
              :items="months"
              return-object
              solo
              flat
              v-model="source_month"
            ></v-select>
          </v-col>

          <v-col cols="2">
            <span>Source Year:</span>
            <input class="form-control" v-model="source_year" />
          </v-col>

          <v-spacer></v-spacer>

          <v-col cols="2">
            <span>Dest. Month:</span>
            <v-select
              class="form-control"
              :items="months"
              return-object
              solo
              flat
              v-model="dest_month"
            ></v-select>
          </v-col>

          <v-col cols="2">
            <span>Dest. Year:</span>
            <input class="form-control" v-model="dest_year" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-row justify="end">
          <v-btn
            small
            color="primary"
            class="font-weight-bold mr-2"
            tile
            depressed
            @click="copyRatesIntoMonthYear"
            >COPY</v-btn
          >

          <v-btn
            small
            color="error"
            class="font-weight-bold ml-2"
            tile
            depressed
            @click="onDialogClose"
            >CLOSE</v-btn
          >
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import constant from "@/const";
export default {
  props: ["dialog", "resource", "monthyear"],

  data() {
    return {
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 8000,

      dataUpdated: false,

      source_month: "JAN",
      source_year: null,

      dest_month: "FEB",
      dest_year: null,

      months: [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ],
    };
  },

  watch: {
    // dialog: function () {
    //   if (dialog) {
    //     // this.fetch_mon_yr_headers();
    //     console.log("dialog is true from watcher");
    //   }
    // },
  },

  async created() {
    if (this.monthyear != null) {
      this.initMonthYear();
    } else {
      await this.fetch_mon_yr_headers();
      this.initMonthYear();
    }
  },

  mounted() {},

  methods: {
    /**
     * fetch month year header for pricing rates
     */
    async fetch_mon_yr_headers() {
      var resp = await this.$https.get("/api/pts/mon_yr_headers/12");
      this.monthyear = resp.data.month_year_data;
    },

    /**
     * Initialise the source and dest month year
     */
    initMonthYear() {
      let smy = this.monthyear.current_my.split("-");
      let dmy = this.monthyear.next_my.split("-");
      this.source_month = smy[0];
      this.source_year = smy[1];
      this.dest_month = dmy[0];
      this.dest_year = dmy[1];
    },

    /**
     * Copy rates into new month
     */
    async copyRatesIntoMonthYear() {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;
      let smy = `${this.source_month}-${this.source_year}`;
      let dmy = `${this.dest_month}-${this.dest_year}`;

      var resp = await this.$https.post(
        `/api/pts/${this.resource}/copy/${smy}/to/${dmy}`
      );

      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.showSnackbar = true;
        this.snackbarColor = "success";
        this.snackbarMsg = resp.data.msg;
        this.dataUpdated = true;
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
      }

      // console.log("smy: ", smy);
      // console.log("dmy: ", dmy);
      // console.log("resource: ", this.resource);
      // console.log(`/api/pts/${this.resource}/copy/${smy}/to/${dmy}`);

      this.$root.blockUIshow = false;
    },

    onDialogClose() {
      this.$emit("dialog-close", this.dataUpdated);
    },
  },

  computed: {},
};
</script>

<style scoped></style>
